import {Switch} from "react-vcomponents";
import {BaseComponent, BaseComponentPlus} from "react-vextensions";
import {store} from "../Store/index.js";
import {Me, MeID} from "../Server/DB/users.js";
import {Observer, PageContainer, SubNavBar_Auto} from "web-vcore";
import {HasModPermissions} from "../Server/DB/users/$user.js";
import {ActivitiesUI} from "./Timeline/Activities";
import {TimelineUI} from "./Timeline/TimelineUI";
import {SessionsUI} from "./Timeline/Sessions";
import React from "react";
import {observer_mgl} from "mobx-graphlink";

export const columnWidths = [.64, .06, .12, .18];

export const TimelinePage = observer_mgl(()=>{
	//const user = Me();
	const uiState = store.main.timeline;
	const currentSubpage = uiState.subpage;
	//if (user == null) return null;
	const page = "timeline";
	const hideSubNavBar = uiState.subpage == "timeline" && uiState.screenshotMode;

	return (
		<>
			{!hideSubNavBar && <SubNavBar_Auto page={page} filter={a=>a.key == "sessions" || HasModPermissions(MeID())}/>}
			<Switch>
				<SessionsUI/>
				{currentSubpage == "timeline" && <TimelineSubpageUI/>}
				{currentSubpage == "activities" && <ActivitiesUI/>}
			</Switch>
		</>
	);
});

const TimelineSubpageUI = observer_mgl(()=>{
	let me = Me();
	if (me == null) return <div>You must be signed in.</div>;
	return (
		<PageContainer preset="full" style={{margin: 0, padding: 0}}>
			<TimelineUI user={Me()!}/>
		</PageContainer>
	);
});